import { combineReducers } from 'redux';
import lhsReducer from '../lhs/reducers/lhs-reducer';
import configurationReducer from '../lhs/reducers/configuration-reducer';
import rhsReducer from '../rhs/dynamic/reducers/rhs-schema-reducer';
import examplesReducer from '../rhs/dynamic/reducers/examples-reducer';

export default combineReducers({
    lhsReducer,
    configurationReducer,
    rhsReducer,
    examplesReducer
  })